






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import { dynamicPricingService } from '../../services/DynamicPricingService'
import {
  DynamicPricingRequest,
  instanceOfDynamicPricingRequest,
} from '../../interfaces/DynamicPricingRequest.interface'
var hash = require('object-hash')

@Component
export default class DynamicPricingDisplay extends Vue {
  @Getter('global/locale') locale
  @Getter('products/selectedProduct') selectedProduct
  @Getter('products/selectedProductDate') selectedProductDate
  @Getter('products/selectedProductAttributeValues') selectedProductAttributeValues

  private dynamicPricing: any = null
  private previousRequest: DynamicPricingRequest = null

  @Prop({ default: '' }) inventoryLabel: string | ''
  @Prop({ default: 'false'}) hideOriginalPriceSetting: string | 'false'

  @Watch('selectedProductId')
  onSelectedProductChanged()

  created() {
    window.addEventListener('product:attributes:updated', this.onProductAttributesUpdated)
  }

  destroyed() {
    window.removeEventListener('product:attributes:updated', this.onProductAttributesUpdated)
  }

  get inventoryRemaining(): number {
    if (this.dynamicPricing && this.dynamicPricing.inventoryThreshold) {
      return this.productInventoryRemaining <= this.dynamicPricing.inventoryThreshold
        ? this.productInventoryRemaining
        : null
    }

    return null
  }

  get inventoryRemainingText(): string {
    const inventoryLabel = this.inventoryLabel || ''
    const countRemainingMask = '{countRemaining}'
    const countRegex = new RegExp(countRemainingMask, 'ig')

    return inventoryLabel.replace(countRegex, String(this.inventoryRemaining))
  }

  get productDate() {
    return this.selectedProductDate ? this.formattedSelectedProductDate : null;
  }

  get formattedSelectedProductDate() {
    let month = '' + (this.selectedProductDate.getMonth() + 1),
      day = '' + this.selectedProductDate.getDate(),
      year = this.selectedProductDate.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  get productAttributeValues() {
    // convert the string value to an int, or if it can't be converted return the string value
    if (this.selectedProductAttributeValues) {
      // Dynamic pricing can only filter on attributes with a numeric ID as a selected value. This test removes other selected attributes
      const integerValueAttributes = this.selectedProductAttributeValues.filter((v) => /^\d+$/.test(v))
      // Ensure selected attributes are only an array of integer IDs
      return integerValueAttributes.map((v) => parseInt(v))
    }

    return []
  }

  get isOriginalPriceSettingEnabled() : boolean{
    if (this.hideOriginalPriceSetting === 'True') {
      return false
    } else {
      return true
    }
  }

  get productBasePrice(): string {
    if(this.ShowBasePrice){
      return this.$options.filters.removeCurrencyFraction(
        this.productDynamicPricing.basePrice,
        this.locale.language,
        this.locale.currency
      )
    }
    return ''
  }

  get ShowBasePrice() : boolean {
    return this.hasPricingAvailableToCompare && this.basePrice != 0 && this.basePrice > this.currentPriceAsNum && this.isOriginalPriceSettingEnabled ? true : false
  }

  get basePrice(): number {
    if (this.productDynamicPricing?.basePrice) {
      return this.productDynamicPricing.basePrice
    }
    return 0
  }

  get currentPriceAsNum(): number {
    if (this.selectedProduct?.ProductPrice?.Price) {
      return Number(this.getSimpleNumber(this.selectedProduct.ProductPrice.Price))
    }
    return 0
  }

  get hasPricingAvailableToCompare() : boolean {
    if (this.selectedProduct?.ProductPrice?.Price && this.productDynamicPricing?.basePrice) {
      return true
    }
    return false
  }

  get productDynamicPricing(): any {
    if (this.dynamicPricing && this.dynamicPricing.dayPricing) {
      const datePricing = this.dynamicPricing.dayPricing.filter((pricing) => pricing.date == this.productDate)
      return datePricing && datePricing.length ? datePricing[0] : {}
    }

    return {}
  }

  get productInventoryRemaining(): number {
    if (this.dynamicPricing && this.dynamicPricing.inventoryCounts && this.productDate) {
      return this.dynamicPricing.inventoryCounts[this.productDate] || -1
    }

    return -1
  }

  get productPricingRequest(): DynamicPricingRequest {
    if (this.productDate && this.selectedProductId && this.productAttributeValues) {
      return {
        ProductAttributeValueIds: this.productAttributeValues,
        ProductId: this.selectedProductId,
        StartDate: this.productDate,
        EndDate: this.productDate,
      }
    }
  }

  get selectedProductId(): number {
    return this.selectedProduct ? this.selectedProduct.Id : -1
  }

  onProductAttributesUpdated(event) {
    if (!this.productPricingRequest)
      return
    const requestHash = hash(this.productPricingRequest)
    if (requestHash !== this.previousRequest && instanceOfDynamicPricingRequest(this.productPricingRequest)) {
      this.retrieveDynamicPricing()
    }
  }

  onSelectedProductChanged() {
    this.previousRequest = null
    this.dynamicPricing = null
  }

  getSimpleNumber(val) {
    return val.replace(/[^\w\s.]/gi, '')
  }

  async retrieveDynamicPricing() {
    this.dynamicPricing = await dynamicPricingService.postDynamicPricingByProductAttributes(this.productPricingRequest)
    window.dispatchEvent(
      new CustomEvent('product:original-price:updated', {
        detail: this.productDynamicPricing,
      })
    )
    if (this.productPricingRequest)
      this.previousRequest = hash(this.productPricingRequest)
  }
}
